import { Box } from '@dtx-company/shared-components/src/components/atoms/Box/index'
import { FC } from 'react'
import { Image } from '@dtx-company/shared-components/src/components/atoms/Image/index'
import { LargeProductSuitCardData } from '../types'
import { Spacer } from '@dtx-company/shared-components/src/components/atoms/Spacer/index'
import { Text } from '@dtx-company/shared-components/src/components/atoms/Text/index'
import { prismicCachedImage } from '@app/prismic/src/utils'

const ValuePropsColumns: FC<{
  valuePropsText: LargeProductSuitCardData['value_props_list']
  valuePropsImages: LargeProductSuitCardData['value_props_images']
}> = ({ valuePropsText, valuePropsImages }) => {
  if (!valuePropsText || !valuePropsImages) return null
  const imageSrcs = valuePropsImages.map(image => ('text' in image ? image.text : ''))
  const texts = valuePropsText.map(field => ('text' in field ? field.text : ''))
  return (
    <Box
      maxWidth={{ _: '425px', md: '315px' }}
      display={{ _: 'grid' }}
      gridTemplateColumns={`repeat(${texts.length}, 1fr)`}
    >
      {texts?.map((text, idx) => {
        return (
          <Box key={text} flexDirection="column" alignItems="center" mx="4px">
            <Image src={prismicCachedImage(imageSrcs[idx])} alt="" width="20px" height="20px" />
            <Spacer mb="8px" />
            <Text textAlign="center">{text}</Text>
          </Box>
        )
      })}
    </Box>
  )
}

export default ValuePropsColumns
